import React, { useState } from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  // State to toggle the menu
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header
      id="header"
      className="header d-flex flex-column justify-content-center"
    >
      {/* Toggle button for small screens */}
      <i
        className="header-toggle d-xl-none bi bi-list"
        onClick={toggleMenu} // Toggle the menu on click
      ></i>

      {/* Navigation menu */}
      <nav id="navmenu" className={`navmenu ${menuOpen ? "active" : ""}`}>
        <ul>
          <li>
            <Link to={"/student/dashboard"}>
              <i className="bi bi-house navicon"></i>
              <span>Dashboard</span>
            </Link>
          </li>

          <li>
            <Link to={"my-library"}>
              <i className="bi bi-hdd-stack navicon"></i>
              <span>My Library </span>
            </Link>
          </li>
          <li>
            <Link to={"my-vocabulary"}>
              <i className="bi bi-card-list"></i>
              <span> My Notebook </span>
            </Link>
          </li>
          {/* {localStorage.getItem("courseType") === "Non-Test Based" && (
            <> */}
          <li>
            <Link to={"grammar-book"}>
              <i className="bi bi-book"></i>
              <span>My Grammar Book</span>
            </Link>
          </li>
          <li>
            <Link to={"my-answers"}>
              <i className="bi bi-check2-circle"></i>
              <span>My Answers</span>
            </Link>
          </li>
          <li>
            <Link to={"feedbacks"}>
              <i className="bi bi-chat-dots"></i>
              <span>Feedbacks</span>
            </Link>
          </li>
          {/* </>
          )} */}
        </ul>
      </nav>
    </header>
  );
};

export default Sidebar;
